import script from "./ThemeEditorFeatureSelectorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeEditorFeatureSelectorModal.vue?vue&type=script&setup=true&lang=js"

import "./ThemeEditorFeatureSelectorModal.vue?vue&type=style&index=0&id=12891376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12891376"]])

export default __exports__